<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Entry -->
        <b-col
          cols="12"
          md="9"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('globalActions.find')"
            />
          </div>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            :to="{ name: 'apps-transactions-purchase-order-add'}"
          >
            <feather-icon icon="PlusIcon" /> {{ $t('apps.transactions.purchase.order.actions.create') }}
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-table
      id="refListTable"
      ref="refListTable"
      no-provider-paging
      no-provider-filtering
      :filter-included-fields="columnToBeFilter"
      :fields="tableColumns"
      :items="itemLists"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="searchQuery"
      responsive
      primary-key="id"
      show-empty
      :busy="isBusy"
      :empty-text="$t('globalSingular.noMatching')"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-primary my-2 d-flex flex-column justify-content-center">
          <div class="text mb-1">
            <b-spinner class="align-middle" />
          </div>
          <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
        </div>
      </template>

      <!-- Column: code -->
      <template #cell(code)="{item}">
        <b-link
          :to="{ name: 'apps-transactions-purchase-order-detail', params: { id: item.id }}"
          class="font-weight-bolder"
        >
          <span class="font-weight-bolder d-block text-nowrap">
            {{ item.code }}
          </span>
        </b-link>
      </template>

       <!-- Column: code -->
      <template #cell(image)="{item}">
        <div v-if="item.name_file !== null">
        <b-link
          :to="{ name: 'apps-transactions-purchase-order-listimage', params: { id: item.id }}"
          class="font-weight-bolder"
        >
          <span class="font-weight-bolder d-block text-nowrap">
            <feather-icon
              icon="FileTextIcon"
              size="21"
            />
          </span>
        </b-link>
        </div>
        <div v-else>
          -
        </div>
      </template>

      <!-- Column: PR -->
      <template #cell(pr)="{ item }">
        <span class="font-weight-bolder d-block text-nowrap">
          <div v-if="item.pr !== null">
            {{ item.pr.code }}
          </div>
          <div v-else>
           -
         </div>
        </span>
      </template>

      <!-- Column: Lab -->
      <template #cell(label)="{ item }">
        <span class="font-weight-bolder d-block text-nowrap">
          {{ item.contact.label }}
        </span>
        <small class="font-italic">{{ item.remark }}</small>
      </template>

      <!-- Column: Amount -->
      <template #cell(amount)="{ item }">
        <span class="font-weight-bolder d-block text-nowrap">
          {{
            formatCurrency(item.sum_of_bill_amount)
          }}
        </span>
      </template>

      <!-- Column: Audit -->
      <template #cell(audit)="{ item }">
        <span class="font-weight-bolder d-block text-nowrap">
        {{ item.updated_process }}  By {{ item.getUser.user_name }}
        </span>
        <small class="font-italic">{{ new Date(item.updated_at).toDateString() }}</small>
      </template>

      <!-- Column: Tags -->
      <template #cell(tags)="{ item }">
        <div class="d-flex">
          <b-badge v-for="(tag, index) in item.tags" :key="index" pill variant="light-primary">{{ tag.name }}</b-badge>
        </div>
      </template>

      <!-- Column: actions -->
      <template #cell(actions)="{item}">
        <div>
        <b-link
          :to="{ name: 'apps-transactions-purchase-order-prints-v2', params: { id: item.id }}"
          class="font-weight-bolder"
        >
          <span class="font-weight-bolder d-block text-nowrap">
           <feather-icon
            icon="FileTextIcon"
            size="21"
          />
          </span>
        </b-link>
        </div>
      </template>
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t('globalSingular.showing') }} {{ dataMeta.from }} {{ $t('globalSingular.to') }} {{ dataMeta.to }} {{ $t('globalSingular.of') }} {{ dataMeta.of }} {{ $t('globalSingular.entries') }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalList"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            aria-controls="refListTable"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

  </b-card>
</template>
<script>
import {
  BCard,
  BButton,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BLink,
  BPagination,
  BSpinner,
  BBadge
} from 'bootstrap-vue'

import { formatCurrency } from '@/utils/formatter'
import useListTable from '@/comp-functions/useListTable'

// to access i18n
import useLocalization from '@/comp-functions/utils/useLocalization'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BPagination,
    BSpinner,
    BBadge
  },
  setup () {
    const { $t } = useLocalization()

    // Table Handlers
    const tableColumns = [
      { key: 'code', label: '#' },
      { key: 'image', label: $t('globalSingular.document'),thClass: 'text-center', tdClass: 'text-center' },
      { key: 'pr', label: 'No.PR', sortable: true  },
      { key: 'date', label: $t('globalSingular.date'), sortable: true  },
      { key: 'getOffice.brand', label: $t('globalSingular.branch') },
      { key: 'contact.brand', label: $t('globalSingular.vendor'), sortable: true  },
      { key: 'remark', label: $t('globalSingular.description') },
      { key: 'amount', label: $t('globalSingular.amount'), thClass: 'text-right', tdClass: 'text-right' },
      { key: 'tags', label: $t('globalSingular.tags') },
      { key: 'audit', label: $t('globalSingular.audit') },
      { key: 'actions', label: $t('globalSingular.actions'), thClass: 'text-center', tdClass: 'text-center' }
    ]
    
    // Table Handlers
    const columnToBeFilter = [
      'code',
      'contact',
      'amount',
      'remark'
    ]

    return {
      formatCurrency,
      tableColumns,
      columnToBeFilter,
      ...useListTable({
        url: 'transaction_orders/purchase/invoice_order'
      })
    }
  }
}
</script>
